// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__23w3V","unreadBadge":"styles_unreadBadge__19h3b","modalContent":"styles_modalContent__3NjvH","modal":"styles_modal__2siS5"};